import { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import api from "../../services/api";

export default function AdminDashboard(){

const [stats,setStats]=useState({
blocks:0,
departments:0,
schemes:0,
users:0
});

useEffect(()=>{

api.get("/admin/dashboard")
.then(res=>setStats(res.data))
.catch(err=>console.log(err));

},[]);

return(

<div className="min-h-screen bg-gray-50">

<Navbar/>

<div className="max-w-7xl mx-auto p-10">

<h2 className="text-2xl font-bold mb-8">
Admin Dashboard
</h2>

<div className="grid grid-cols-1 md:grid-cols-4 gap-6">

<div className="bg-white shadow rounded p-6">
<p className="text-gray-500">Blocks</p>
<h3 className="text-3xl font-bold">{stats.blocks}</h3>
</div>

<div className="bg-white shadow rounded p-6">
<p className="text-gray-500">Departments</p>
<h3 className="text-3xl font-bold">{stats.departments}</h3>
</div>

<div className="bg-white shadow rounded p-6">
<p className="text-gray-500">Schemes</p>
<h3 className="text-3xl font-bold">{stats.schemes}</h3>
</div>

<div className="bg-white shadow rounded p-6">
<p className="text-gray-500">Users</p>
<h3 className="text-3xl font-bold">{stats.users}</h3>
</div>

</div>

</div>

</div>

)

}